import React, { Fragment } from "react";

import { CopyBlocks } from "custom-types/Directus";

type Props = {
  data: CopyBlocks;
  className?: string;
};

const CopyBlock = ({ data, className }: Props) => {
  return (
    <div className={className}>
      {data?.copy_block?.map((block, idx) => (
        <Fragment key={`${block.header}-${idx}`}>
          <h2 className="text-xs font-bold uppercase mb-sm">{block.header}</h2>
          <p
            className="text-xs mb-lg"
            dangerouslySetInnerHTML={{ __html: block.copy }}
          />
        </Fragment>
      ))}
    </div>
  );
};

export default CopyBlock;
